import {
  SAFE_AREA_MODE_UA_TOKEN,
  SAFE_AREA_CACHE_KEY,
  SAFE_AREA_CACHE_MAX_AGE_MS,
} from "@/src/utils/safeAreaPolicy";

/**
 * 在 React/hydration 之前尽可能先把默认安全区写入（仅在 app webview 环境）
 * 这样可以显著减少“原生端注入过晚导致的顶部闪动”。
 *
 * 注意：此脚本运行在浏览器环境，不能依赖打包后的函数引用，因此必须是纯字符串逻辑。
 *
 */
export const SAFE_AREA_STARTUP_SCRIPT = `(function () {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    var root = document.documentElement;
    if (!root) return;

    var ua = (navigator && navigator.userAgent) ? navigator.userAgent : '';
    var uaLower = (ua || '').toLowerCase();
    var isAndroid = /Android/i.test(ua);
    var isIOS = /iPhone|iPad|iPod/i.test(ua);

    // WebView 近似判断：Android UA 通常含 wv；iOS 可用 webkit.messageHandlers
    var isAndroidWebView = isAndroid && (/\\bwv\\b/i.test(ua) || /Version\\/\\d+\\.\\d+/i.test(ua));
    var isIOSWebView = isIOS && !!(window.webkit && window.webkit.messageHandlers);
    var isInApp = isAndroidWebView || isIOSWebView;
    if (!isInApp) return;
    var safeAreaMode = (ua || '').indexOf('${SAFE_AREA_MODE_UA_TOKEN}fixed') >= 0 ? 'fixed' : 'dynamic';

    function setVar(name, v) {
      if (typeof v !== 'number' || !isFinite(v) || v < 0 || v > 300) return;
      root.style.setProperty(name, Math.round(v) + 'px');
    }

    // fixed 模式：完全信任 Web 固定值，忽略原生注入与缓存
    if (safeAreaMode === 'fixed' && isAndroidWebView) {
      setVar('--safe-area-inset-top', 0);
      setVar('--safe-area-inset-right', 0);
      setVar('--safe-area-inset-bottom', 16);
      setVar('--safe-area-inset-left', 0);
      return;
    }

    // 如果当前已经有非 0 值（env() 或原生已覆盖），不做任何事
    var cs = window.getComputedStyle ? getComputedStyle(root) : null;
    var curTop = 0, curBottom = 0;
    if (cs) {
      curTop = parseInt(cs.getPropertyValue('--safe-area-inset-top') || '0', 10) || 0;
      curBottom = parseInt(cs.getPropertyValue('--safe-area-inset-bottom') || '0', 10) || 0;
    }
    if (curTop > 0 || curBottom > 0) return;

    // 尝试读取缓存（上一次原生注入）
    var key = '${SAFE_AREA_CACHE_KEY}';
    var maxAge = ${SAFE_AREA_CACHE_MAX_AGE_MS};
    var cached = null;
    try {
      var raw = window.localStorage ? window.localStorage.getItem(key) : null;
      if (raw) {
        var obj = JSON.parse(raw);
        if (obj && typeof obj.ts === 'number' && (Date.now() - obj.ts) <= maxAge) {
          cached = obj;
        }
      }
    } catch (e) {}

    if (cached && typeof cached === 'object') {
      setVar('--safe-area-inset-top', cached.top);
      setVar('--safe-area-inset-right', cached.right);
      setVar('--safe-area-inset-bottom', cached.bottom);
      setVar('--safe-area-inset-left', cached.left);
      return;
    }

    // 常规默认值：iOS 44/34；Android 按厂商略微细分
    var top = 0, bottom = 0;
    if (isIOSWebView) {
      top = 44; bottom = 34;
    } else if (isAndroidWebView) {
      var vendor = 'other';
      if (/\\bpixel\\b/.test(uaLower)) vendor = 'google';
      else if (/\\bsm-|\\bsamsung\\b|\\bgt-|\\bsch-|\\bscv-|\\bshv-/.test(uaLower)) vendor = 'samsung';
      top = (vendor === 'samsung') ? 28 : 24;
      bottom = 16;
    }
    setVar('--safe-area-inset-top', top);
    setVar('--safe-area-inset-right', 0);
    setVar('--safe-area-inset-bottom', bottom);
    setVar('--safe-area-inset-left', 0);
  } catch (e) {}
})();`;
